import {Heading, useTheme} from '@primer/react'

import {Search} from '../Search/Search'

import styles from './Header.module.css'

import McpLogo from './McpLogo.png'
import McpLogoDark from './McpLogo-dark.png'

type Props = {
  searchQuery: string
  onSearchChange: (query: string) => void
}

export function Header({searchQuery, onSearchChange}: Props) {
  const {resolvedColorScheme} = useTheme()
  const isDarkMode = resolvedColorScheme?.startsWith('dark')
  const logoSrc = isDarkMode ? McpLogoDark : McpLogo

  return (
    <header className={styles.header}>
      <img src={logoSrc} alt="MCP logo" width="86" height="76" />

      <div className={styles.content}>
        <Heading as="h1" className={styles.heading}>
          Connect models to the real world
        </Heading>

        <p className={styles.subheading}>
          Servers and tools from the community that connect models to files, APIs, databases, and more.
        </p>
      </div>

      <Search searchQuery={searchQuery} onSearchChange={onSearchChange} />
    </header>
  )
}
